import React from 'react';
import { IconProps } from '../types';
const MinecraftLingeringPotion: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="5" width="1" height="1" fill="rgba(212, 109, 73, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(212, 109, 73, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(151, 55, 22, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(212, 229, 247, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(151, 55, 22, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(179, 207, 236, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(179, 207, 236, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(212, 229, 247, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(179, 207, 236, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(179, 207, 236, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(212, 229, 247, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(179, 207, 236, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(212, 229, 247, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(179, 207, 236, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(179, 207, 236, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(139, 173, 208, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(139, 173, 208, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(139, 173, 208, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(93, 143, 194, 255)" />
</svg>);
export default MinecraftLingeringPotion;